// Modules
import moment from "moment";
import React from "react";
//@ts-ignore
 import {LocalizationContext} from "react-localize";

// Styles
import "./WaitlistCriteria.sass";

type Props = {
  checkIn: Date | string;
  expirationLeadTime: number | undefined;
  setExpirationLeadTime(days: number): void;
  readOnly: boolean;
};

class WaitlistCriteria extends React.Component<Props> {
  constructor(props: Readonly<Props>) {
    super(props);
  }

  onExpirationLeadTimeChange = (e: any) => {
      const expirationLeadTime = e.target.value;
      if (expirationLeadTime === "0" || expirationLeadTime === "" || Number(expirationLeadTime))
        this.props.setExpirationLeadTime(expirationLeadTime);
      else
        return;
  }

  getExpirationDate = () => {
    //calculate date
    const days = this.props.expirationLeadTime ? this.props.expirationLeadTime : 0;
    const expirationDate = moment(this.props.checkIn).subtract(days, 'days')
    return expirationDate.format("DD MMMM YYYY")
  }
  
  render() {
    const {localize} = this.context;

    const readOnly = this.props.readOnly;

    return (
      <div className="waitlist-criteria-container">
        <div className='inner-container'>
          <div>
            <div className='criteria-header'>
               {/* {localize("static.content.sr-waitlist-criteria-header")} */}
               Waitlist Criteria
            </div>
              {/* content should be managed in jahia and have 2 variables, 1 for days and 1 for date, or 2 content elements for text before <input> and text after */}
              {/* can jahia content contain an input and then we react to the value of that input??? */}
              <p>
                {'If my waitlist is not fullfilled before '}
                {readOnly ?
                  this.props.expirationLeadTime ? this.props.expirationLeadTime : "0"
                :
                  <input type="text" id="expirationLeadTime" value={this.props.expirationLeadTime} onChange={this.onExpirationLeadTimeChange}/>
                }
                {' days prior to arrival, please cancel my waitlist request and return my points.'}
              </p>
              <p>
                Waitlist will return points on: <b>{this.getExpirationDate()}</b>
              </p>
          </div>
        </div>
      </div>
    );
  }
}

WaitlistCriteria.contextType = LocalizationContext;

export default WaitlistCriteria;
